import { gracefullyPlayAudio } from "../../audio";
import { NOTIFICATION_VOLUME } from "../../config";
import { debounce } from "../../utils";
import outOfNowhereToneUri from "../../assets/audio/out-of-nowhere-tone.mp3?url";
import { useRecordProviderNoShowReportCallback } from "./useRecordProviderNoShowReportCallback";
import { useEffect } from "react";
import { useClearProviderNoShowTabTitleCallback } from "./useClearProviderNoShowTabTitle";
import { setAlertTitle } from "../../metadata";
import { useTranslate } from "@growtherapy/i18n";

const DEBOUNCE_TIME_MS = 1000;

const playPastProviderGracePeriodSound = debounce(() => {
  const ringtone = new Audio(outOfNowhereToneUri);
  ringtone.volume = NOTIFICATION_VOLUME;
  gracefullyPlayAudio(ringtone);
}, DEBOUNCE_TIME_MS);

export function useUpdateTitleOnProviderPastNoShowThreshold() {
  const t = useTranslate();
  const { isPastNoShowThreshold } = useRecordProviderNoShowReportCallback();
  const clearProviderNoShowTabTitle = useClearProviderNoShowTabTitleCallback();
  const providerNoShowTitle = t("telehealth-core:meta.providerNotHere");

  useEffect(
    function showProviderNotHereTabTitle() {
      if (!isPastNoShowThreshold) return;
      setAlertTitle(providerNoShowTitle);
      playPastProviderGracePeriodSound();
    },
    [providerNoShowTitle, isPastNoShowThreshold],
  );

  useEffect(function resetProviderNoShowTitleOnLeaveWaitingRoom() {
    return () => {
      if (document.title !== providerNoShowTitle) return;
      clearProviderNoShowTabTitle();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
